// @flow
import React from 'react';
import Grid from '@material-ui/core/Grid';
import Text from 'UI/components/atoms/Text';
import EmptyPlaceholder from 'UI/components/templates/EmptyPlaceholder';
import { NotificationEmptyImg } from 'UI/res';

const NotificationEmpty = () => {
  return (
    <Grid
      container
      direction="column"
      alignItems="center"
      justify="center"
      style={{ position: 'relative', height: '100%' }}
    >
      <EmptyPlaceholder
        title="Nothing to show here"
        subtitle="Your notifications will appear here."
        customEmptyState={<NotificationEmptyImg />}
      >
        <Text text="Please check back later" variant="body2" />
      </EmptyPlaceholder>
    </Grid>
  );
};

export default NotificationEmpty;
